export enum EConsoleType {
    SUCCESS = 0,
    ERROR = 1,
    WARNING = 2
}

//TODO: Outsourcing this into the Prizific UI library

/**
 * Logs a styled console message based on the specified type.
 *
 * @param type The type of console message (SUCCESS, WARNING, ERROR).
 * @param title The title of the console message.
 * @param message The content of the console message.
 * @returns void
 */
export function useConsoleMessage(type: EConsoleType, title: string, message: any) {
    const commonCss = `border-radius: 4px; 
    padding: 4px 8px;
    border: 1px solid;
    margin-bottom: 4px;
    `
    const successCss = `background: #1c2518; 
        color: #67c23a; 
        border-color: #3e6b27; ${commonCss}`
    const warningCss = `background: #292218;
         color: #e6a23c; 
         border-color: #7d5b28; ${commonCss}`
    const errorCss = `background: #2b1d1d; 
        color: #f56c6c; 
        border-color: #854040; ${commonCss}`

    if (type == EConsoleType.SUCCESS) {
        return console.log(`%c${title}`, successCss, message)
    } else if (type == EConsoleType.WARNING) {
        return console.warn(`%c${title}`, warningCss, message)
    } else if (type == EConsoleType.ERROR) {
        return console.error(`%c${title}`, errorCss, message)
    }

    return
}
